import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_FR.json';
import recipes from './COOKING_RECIPES_FR.json';
import videos from './COOKING_VIDEOS_FR.json';

export const COOKING_DATA_FR: ServiceData = {
  articles,
  recipes,
  videos,
};
